import $ from "jquery";
import ScriptHelper from "base/ScriptHelper";
import {MAP_STYLES, initMarker} from "util/map";

let infowindow;

export function loadDaisyCottageGoogleMap($element) {
    ScriptHelper.load_script("https://maps.googleapis.com/maps/api/js?key=AIzaSyALIV9KE7xv-qRbMO1TKxXExkuBO5yS6sQ").then(() => {
        loadDaisyCottageMap($element);
    });
}

function loadDaisyCottageMap($element) {
    const mapOptions = {
        disableDefaultUI: false,
        center: new google.maps.LatLng(0, 0),
        styles: MAP_STYLES,
        gestureHandling: 'cooperative',
        backgroundColor: '#FFF',
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: true,
        fullscreenControl: false,
        zoom: 17,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    let $markers = $element.find('.js-marker');

    let map = new google.maps.Map($element[0], mapOptions);

    map.markers = [];

    $markers.each((function () {
        initMarker($(this), map);
    }));

    let latLng = {
        lat: parseFloat(52.276571),
        lng: parseFloat(-1.593633)
    };

    let marker = new google.maps.Marker({
        position: latLng,
        map: map,
        icon: {
            url: '/wp-content/themes/park-cottage/images/svg/daisy-cottage-marker.svg',
            scaledSize: new google.maps.Size(45, 65),
            labelOrigin: new google.maps.Point(22, 65),
        }
    });

    marker.addListener('click', function () {
        if (infowindow) infowindow.close();
        this.setAnimation(null);

        let $content = (
            eotwJSXFactory('div', {className: "map-tooltip map-tooltip--daisy-cottage"}, [
                eotwJSXFactory('h2', {className: "heading map-tooltip__heading"}, ["Daisy Cottage"]),
                eotwJSXFactory('p', null, ["115 West Street", eotwJSXFactory('br'),
                    "Warwick", eotwJSXFactory('br'),
                    "CV34 6AH"
                ]),
                eotwJSXFactory('a', {className: "map-tooltip__link", target: "_blank", rel: "noreferrer", href: "https://www.google.com/maps/dir/?api=1&destination=115+West+St,+Warwick+CV34+6AH"}, ["Get directions"])
            ])
        );

        infowindow = new google.maps.InfoWindow({
            content: $content[0]
        });

        setTimeout(function () {
            $('.gm-style-iw-a').addClass('active');
        }, 100)

        infowindow.open(map, marker);
    });

    map.markers.push(marker);

    let bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    map.setCenter(bounds.getCenter());
}